(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initialize(scope) {
    scope.querySelectorAll('[data-field-functions]').forEach(section => {
      if (section.dataset.functionsReady === 'true') return;
      section.dataset.functionsReady = 'true';
      const tabs = [...section.querySelectorAll('[data-function-tab]')];
      const panels = [...section.querySelectorAll('[data-function-panel]')];
      const tablist = section.querySelector('[role="tablist"]');
      function activate(index, focus) {
        const active = tabs[index];
        if (!active) return;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        panels.forEach(panel => {
          const selected = panel.dataset.functionPanel === active.dataset.functionTab;
          panel.hidden = !selected;
          panel.classList.toggle('is-entering', selected && !reduced);
        });
        if (focus) active.focus({ preventScroll: true });
        if (tablist && tablist.scrollWidth > tablist.clientWidth) {
          const left = active.offsetLeft - tablist.offsetLeft - (tablist.clientWidth - active.offsetWidth) / 2;
          tablist.scrollTo({ left, behavior: reduced ? 'instant' : 'smooth' });
        }
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index, false));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(next, true);
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target.parentElement || document));
})();
